import api from '@/api'

export default {
  namespaced: true,
  state: {
    orders: [],
    ordersInfo: {},
    reasonsToCancel: [],
    isLoading: false
  },
  mutations: {
    SET_ORDERS (state, data) {
      state.orders = data
    },
    SET_ORDERS_INFO (state, info) {
      state.orders = [...state.orders, ...info.orders]
      state.ordersInfo = info
    },
    SET_IS_LOADING (state, bool) {
      state.isLoading = bool
    },
    SET_REASONS (state, data) {
      state.reasonsToCancel = data
    },
    RESET_ORDERS_INFO (state) {
      state.orders = []
      state.ordersInfo = {}
    }
  },
  actions: {
    GET_ORDERS_INFO ({ commit, state }) {
      const params = {}

      if (state.ordersInfo?.offset) params.offset = state.ordersInfo.offset

      commit('SET_IS_LOADING', true)

      api.cabinet.getOrders(params)
        .then(res => {
          if (res.status === 'success') {
            commit('SET_ORDERS_INFO', res)
          }
        })
        // .catch(err => {
        //   console.log(err)
        // })
        .finally(() => {
          commit('SET_IS_LOADING', false)
        })
    },
    GET_ORDER_WARRANTY_CARD ({ commit, state }, id) {
      const params = {
        order_id: id
      }
      api.cabinet.getWarrantyCard(params)
        .then(res => {
          window.open(URL.createObjectURL(res))
        })
    },
    RESET_ORDERS_INFO_ACTION ({ commit }) {
      commit('RESET_ORDERS_INFO')
    },
    async GET_CANCEL_REASONS ({ commit }) {
      await api.cabinet.getCancelReasons()
        .then(res => {
          commit('SET_REASONS', res)
        })
    },
    CANCEL_ORDER (ctx, data) {
      return api.cabinet.cancelOrder(data)
    },
    CHANGE_ORDERS (ctx, data) {
      ctx.commit('SET_ORDERS', data)
    }
  }
}
